// import logger from 'redux-logger'
import thunk from 'redux-thunk'
import LocalForageMiddleWare from './LocalForageMiddleware'
import LauncherCommandMiddleware from './LauncherCommandMiddleware'
import NotifierMiddleware from './NotifierMiddleware'
import UserProfileMiddleware from './UserProfileMiddleware'
import SyncMiddleware from './SyncMiddleware'
import ClientProcessMiddleware from './ClientProcessMiddleware'
import LoggerMiddleware from './LoggerMiddleware'
import LanguageMiddleware from './LanguageMiddleware'
import LogoutMiddleware from './LogoutMiddleware'
import SteamMiddleware from './SteamMiddleware'
import ServerMiddleware from './ServerMiddleware'
import VersionsMiddleware from './VersionsMiddleware'
import { featureMiddlewares } from '../features'
// todo: settings Fix language maybe create a middleware array in features...?

const Middlewares = [
    // logger,
    thunk,
    LauncherCommandMiddleware,
    LocalForageMiddleWare,
    NotifierMiddleware,
    UserProfileMiddleware,
    ClientProcessMiddleware,
    LoggerMiddleware,
    SyncMiddleware,
    LanguageMiddleware,
    SteamMiddleware,
    LogoutMiddleware,
    ServerMiddleware,
    VersionsMiddleware,
    ...featureMiddlewares,
]

export default Middlewares



// WEBPACK FOOTER //
// ./src/middlewares/index.js